export default __webpack_public_path__ + "static/media/004-carousel.949ea79b.svg";